import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidMicrophoneIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 15c2.2 0 4-1.8 4-4V5c0-2.2-1.8-4-4-4S8 2.7 8 5v6c0 2.3 1.8 4 4 4Zm8-4c0-.6-.4-1-1-1s-1 .4-1 1c0 3.3-2.7 6-6 6s-6-2.7-6-6c0-.6-.4-1-1-1s-1 .4-1 1c0 4 3 7.4 7 7.9V21H9c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1h-2v-2.1c4-.5 7-3.9 7-7.9Z"/>
  </SvgIcon>
}

export default SolidMicrophoneIcon
